<template>
  <div class="top">
    <component :is="topPageComponent" />
  </div>
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";
import Welcome from "@/components/Welcome.vue";

import { useAuth } from "@/submodules/auth";
import { defineComponent, computed } from "@vue/composition-api";

import { useMainStore } from '@/stores/mainStore'

export default defineComponent({
  name: "Top",
  components: {
    Dashboard,
    Welcome,
  },
  setup() {
    const topPageComponent = computed(() => {
      const { loggedIn } = useAuth();
      return loggedIn() ? "dashboard" : "welcome";
  });

    const main = useMainStore()
    console.log('main', main)
    console.log('main.increment', main.increment())
    console.log('main.counter', main.counter)
    const computedMainCounter = computed(() => {
      return main.count
    })
    console.log('Top.vue setup CALLED!')

    return {
      topPageComponent,
      computedMainCounter,
    };
  },
});
</script>

<style lang="scss" scoped>
.top {
  height: 100%;
}
.renewal-text {
  font-weight: bold;
  color: #4889DD;
}
</style>
